<template>
  <span :title="text">{{handleText}}</span>
</template>

<script>
export default {
  name: 'EllipsisText',
  props: {
    text: {
      type: String,
      default: ''
    },
    showTextCount: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    handleText() {
      const number = this.showTextCount
      if (this.text.length - number > 0) {
        const subText = this.text.substring(0, number)
        return `${subText}...`
      } else {
        return this.text
      }
    }
  }
}
</script>

<style scoped>

</style>
